/** @type {Map<string, object|null>} */
const cache = new Map();

/** @type {Map<string, Promise<object|null>>} */
const inflight = new Map();

/**
 * 按 slug 去重 Gamma 请求：内存缓存 + in-flight Promise 合并。
 * @param {string} slug
 * @param {(slug: string) => Promise<object|null>} fetchFn
 * @returns {Promise<object|null>}
 */
export async function fetchGammaEventCached(slug, fetchFn) {
  const s = String(slug || '').trim();
  if (!s) return null;

  if (cache.has(s)) {
    return cache.get(s);
  }

  const pending = inflight.get(s);
  if (pending) {
    return pending;
  }

  const promise = fetchFn(s)
    .then((event) => {
      cache.set(s, event ?? null);
      return event ?? null;
    })
    .catch((err) => {
      console.warn(`[gamma] cached fetch failed slug=${s}`, err);
      cache.set(s, null);
      return null;
    })
    .finally(() => {
      inflight.delete(s);
    });

  inflight.set(s, promise);
  return promise;
}

/** @param {string} slug */
export function getCachedGammaEvent(slug) {
  const s = String(slug || '').trim();
  if (!s || !cache.has(s)) return undefined;
  return cache.get(s);
}

export function clearGammaEventCache() {
  cache.clear();
  inflight.clear();
}
